export default {
  get: (username = null) => [
    'get',
    `/api/status${username ? `?username=${username}` : ''}`,
  ],
};
